module.exports = __webpack_public_path__ + "static/media/retail-store-2400x1472.fd604b5a.jpg";